import { render, staticRenderFns } from "./ProductBlock.vue?vue&type=template&id=dcfc33f6&scoped=true&"
import script from "./ProductBlock.vue?vue&type=script&lang=js&"
export * from "./ProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductBlock.vue?vue&type=style&index=0&id=dcfc33f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfc33f6",
  null
  
)

export default component.exports